'use strict';

var React = require('react');

var SvgLogoTiktokIcon = function SvgLogoTiktokIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 6.295c-1.92-.121-3.028-1.306-3.263-3.295l-2.306.008v8.367c.349 4.465-3.839 3.789-4.166 1.503-.167-1.192.432-1.875 1.502-2.232a6.841 6.841 0 0 1 1.109-.273v-2.362c-4.796.167-5.715 4.473-4.22 6.918 2.322 3.804 8.112 2.148 8.112-3.167v-4.176c1.138.683 2.117 1.048 3.232.942v-2.233Z"
  }));
};
SvgLogoTiktokIcon.displayName = "LogoTiktokIcon";

exports.SvgLogoTiktokIcon = SvgLogoTiktokIcon;
